import React, { useCallback } from "react";
import { ChakraProps } from "@chakra-ui/react";
import { AsyncSearchProvider } from "./AsyncSearchProvider";
import AsyncSelect from "./AsyncSelect";

type TimeOfDay = "morning" | "day" | "evening" | "night";

const timeOfDays: TimeOfDay[] = ["morning", "day", "evening", "night"];

interface SelectTimeOfDayProps extends ChakraProps {
  value: string;
  setValue: (value: string) => void;
}

const SelectTimeOfDay: React.FC<SelectTimeOfDayProps> = ({ color, value, setValue, ...chakraProps }) => {
  const handleSearch = useCallback(async (searchQuery?: string): Promise<[string, string][]> => {
    return timeOfDays
      .filter((timeOfDay) => (searchQuery ? timeOfDay.toLowerCase().includes(searchQuery.toLowerCase().trim()) : true))
      .sort((a, b) => a.localeCompare(b))
      .map((timeOfDay) => [timeOfDay, timeOfDay]);
  }, []);

  return (
    <AsyncSearchProvider onSearchAsync={handleSearch}>
      <AsyncSelect
        selectedValue={value}
        setSelectedValue={setValue}
        color={color}
        title={"Time Of Day"}
        {...chakraProps}
      />
    </AsyncSearchProvider>
  );
};

export default SelectTimeOfDay;
